import { useEffect } from 'react';

/**
 * 设置顶级元素背景色
 * @param color
 * @author Kody
 */
export const useSetDocColor = (color: string) => {
    useEffect(() => {
        if (!color) {
            return;
        }
        const doc = document.querySelector('.doc');
        if (doc) {
            doc.setAttribute('style', `background-color: ${color}`);
        }
    }, [color]);
};
